<template>
    <div v-if="client" class="field-list">
        <div v-for="info in infoData" :key="info.label" class="field-row">
            <span class="field-lbl">{{ info.label }}</span>
            <span class="field-val">{{ info.value }}</span>
        </div>
    </div>
</template>

<script>
import { toDate } from "@/utils/Common";

export default {
    name: "BasicInfoProfile",
    props: {
        client: {
            type: Object,
            default: null
        }
    },
    computed: {
        phoneCode(vm = this) {
            return vm.client?.phoneCode || vm.client?.country?.phoneCode || process.env.VUE_APP_COUNTRY_PHONE_CODE
        },
        phone(vm = this) {
            if(vm.client?.phone) return `${vm.phoneCode} ${vm.client.phone}`
            return vm.$t('common.no_set')
        },
        age(vm = this) {
            const birthDate = toDate(vm.client?.birthDate)
            if(birthDate) return vm.$moment().diff(vm.$moment(birthDate), 'years')
            return vm.$t('common.no_set')
        },
        height(vm = this) {
            if(vm.client.height) return `${vm.client.height}cm`
            return vm.$t('common.no_set')
        },
        weight(vm = this) {
            if(vm.client.weight) return `${vm.client.weight}kg`
            return vm.$t('common.no_set')
        },
        infoData(vm = this) {
            return [
                { label: vm.$t('common.email'), value: vm.client.email },
                { label: vm.$t('common.phone'), value: vm.phone },
                { label: vm.$t('common.age'), value: vm.age },
                { label: vm.$t('common.height'), value: vm.height },
                { label: vm.$t('common.weight'), value: vm.weight },
            ]
        }
    }
}
</script>

<style scoped>
.field-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 0;
    border-bottom: 1px solid var(--v-outline-base);
}

.field-row:last-child {
    border-bottom: none;
}

.field-lbl {
    font-size: 12px;
    font-weight: 600;
    color: var(--v-txtSecondary-base);
}

.field-val {
    font-size: 13px;
    font-weight: 500;
    color: var(--v-txtPrimary-base);
    text-align: right;
    word-break: break-word;
}
</style>
